import styled from 'styled-components';

export const ButtonContainer = styled.div<{ topLeft?: boolean }>`
  position: absolute;
  display: flex;
  gap: 4px;
  bottom: 12px;
  left: 12px;
  z-index: 10;

  ${(props) =>
    props.topLeft &&
    `
    top: 12px;
    bottom: auto;
  `}
`;

export const HiddenFileInput = styled.input`
  width: 0 !important;
  height: 0;
  overflow: hidden;
`;

export const createRotatedIcon = (heading: number, mapHeading = 0): google.maps.Icon => {
  // Compensate for map rotation by subtracting the map's heading
  const adjustedHeading = heading - mapHeading;

  const svgMarker = `
    <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <g transform="rotate(${adjustedHeading} 16 16)">
        <path d="M16 2 L24 26 L16 20 L8 26 Z" fill="#FF6B6B" stroke="#FFFFFF" stroke-width="2"/>
      </g>
    </svg>
  `;

  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgMarker)}`,
    size: new google.maps.Size(32, 32),
    anchor: new google.maps.Point(16, 16),
    scaledSize: new google.maps.Size(32, 32),
  };
};
